import "./globals";
import "./setLogLevel";
import "./registerServiceWorker";
// import "@toruslabs/vue-components/style.css";
import "./style.css";

import { createDisplay } from "@toruslabs/vue-components/display";
import { createIcons } from "@toruslabs/vue-components/icons";
import { createPinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { createApp } from "vue";

import App from "./App.vue";
import icons from "./icons";
import i18n from "./plugins/i18n-Setup";
import router from "./routes";
import { installSentry } from "./utils/sentry";

const pinia = createPinia();
pinia.use(
  createPersistedState({
    key: (id) => `__persisted__${id}`,
  })
);

const app = createApp(App);
app.use(i18n).use(router).use(pinia).use(createDisplay()).use(createIcons(icons));
installSentry(app, router);
app.mount("#app");
